import { Box, Group, Image } from "@mantine/core";

import { HeaderLogoIcon } from "@/shared/assets/images";

import LogoutButton from "../logout-button/logout-button";

export default function MobileHeader() {
  return (
    <Box bdrs="lg" bg="primary.1" p="sm">
      <Group justify="space-between" align="center" wrap="nowrap">
        <Image src={HeaderLogoIcon} alt="وی‌بوم" h={30} w={72} fit="contain" />

        <LogoutButton showLabel={false} iconSize={20} />
      </Group>
    </Box>
  );
}
